import { graphql } from '@/gql';
import type { TranscribeQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const transcribeCallLog = async ({ id, force }: TranscribeQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      id,
      force,
    },
    query: graphql(`
      query Transcribe($id: Float!, $force: Boolean) {
        transcribe(id: $id, force: $force) {
          lines
          metaData
          error
          requestedAt
        }
      }
    `),
  });

  return response.data.transcribe;
};
